import { useEffect } from "react";
const useOnBrowserNavigation = (fn) => {
  useEffect(() => {
    window.addEventListener("popstate", fn);
    return () => {
      window.removeEventListener("popstate", fn);
    };
  }, [fn]);
};
export default useOnBrowserNavigation;
